<h2 matDialogTitle>New Transaction</h2>
<div fxLayout="column" matDialogContent data-cy="new-transaction-container">
  <div *ngIf="!selectedCustomer" fxLayoutAlign="row" id="customer-search-container" fxLayout="row"
    fxLayoutAlign="stretch start">
    <mat-form-field [testId]="testIds.CUSTOMER_SEARCH_INPUT" class="pb-16">
      <mat-label>Customer Select</mat-label>
      <input matInput [formControl]="searchTerm" name="Customer select" [matAutocomplete]="auto" name="Search"
        id="customer-search" placeholder="Search for a customer" type="search" />
      <mat-autocomplete (optionSelected)="optionSelectedEvent($event)" name="" #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredCustomers" [value]="option" [testId]="testIds.SEARCH_CUSTOMER_RESULT">
          <div class="flex flex-row justify-between items-start w-full">
            <div class="flex flex-col justify-start items-start flex-grow w-full basis-full">
              <p>{{ option | customerName }}</p>
              <p>
                <small>{{ option.address_1 }}</small>
              </p>
            </div>
            <img *ngIf="option.sage_customer_id" src="/assets/icons/sage.svg"
              class="w-auto h-4 flex-shrink ml-4 mt-3" />
          </div>
        </mat-option>
        <mat-option [value]="false">
          <p><em>Create new customer</em></p>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div *ngIf="selectedCustomer" fxLayout="column" id="selected-customer" fxLayoutGap="36px">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="column" fxFlex="80">
        <p>{{ selectedCustomer | customerName }}</p>
        <p>
          <small>{{ selectedCustomer | customerAddress }}</small>
        </p>
      </div>
      <div fxLayout="column" fxFlex="20" fxLayoutAlign="center center">
        <a (click)="deselectCustomer()"> Change </a>
      </div>
    </div>

    <div [ngSwitch]="transactionProductType">
      <div fxLayout="column" fxLayoutGap="18px" *ngSwitchCase="null">
        <p>What type of transaction is this?</p>
        <mat-radio-group [(ngModel)]="type" [ngModelOptions]="{ standalone: true }"
          class="flex flex-col sm:flex-row sm:gap-x-2 justify-start items-start w-full"
          (change)="transactionTypeChanged($event.value)">
          <mat-radio-button value="hire" [testId]="testIds.IMMEDIATELY_RB" data-testid="immediately-rb">Hire
          </mat-radio-button>
          <mat-radio-button value="sale" [testId]="testIds.SALE_RB" data-testid="sale-rb">Sale
          </mat-radio-button>
          <mat-radio-button value="booking" [testId]="testIds.FUTURE_RB" data-testid="future-rb">Hire booking
          </mat-radio-button>
          <mat-radio-button value="repair" [testId]="testIds.REPAIR_RB" data-testid="repair-rb">Repair
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div fxLayout="column" fxLayoutGap="18px" *ngSwitchCase="'hire'">
        <p>When does this hire start?</p>
        <mat-radio-group [(ngModel)]="type" [ngModelOptions]="{ standalone: true }" fxLayout="row"
          (change)="transactionTypeChanged($event.value)" fxLayoutGap="12px">
          <mat-radio-button value="hire" data-cy="immediately">Immediately - create hire contract
          </mat-radio-button>
          <mat-radio-button value="booking" data-cy="future">Future date - create booking
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div *ngIf="type === 'booking'">
      <form (submit)="create()" [formGroup]="form" fxLayout="column" fxLayoutGap="18px">
        <mat-divider></mat-divider>
        <h4>Booking Details</h4>
        <div class="flex flex-col justify-start items-stretch sm:flex-row sm:gap-x-2">
          <mat-form-field>
            <mat-label>On hire date</mat-label>
            <input data-cy="on-hire-date" matInput [min]="minimumDate" formControlName="on_hire_date"
              name="On hire date" [matDatepicker]="onHirePicker" autocomplete="off" placeholder="On hire date" />
            <mat-datepicker-toggle matSuffix [for]="onHirePicker"></mat-datepicker-toggle>
            <mat-error *ngIf="form.controls['on_hire_date'].hasError('matDatepickerMin')">
              On hire date can not be less than todays date
            </mat-error>
            <mat-error *ngIf="form.controls['on_hire_date'].hasError('matDatepickerMax')">
              On hire date can not be more than off hire date
            </mat-error>
            <mat-datepicker #onHirePicker></mat-datepicker>
          </mat-form-field>

          <!-- <mat-form-field>
            <mat-label>On hire time</mat-label>
            <input
              matInput
              data-cy="on-hire-time"
              placeholder="On hire time"
              timepickerTrigger
              autocomplete="off"
              [timepicker]="timepicker"
            />
            <mat-icon matSuffix>access_time</mat-icon>
            <timepicker
              #timepicker="timepicker"
              formControlName="on_hire_time"
              name="On hire time"
            >
            </timepicker>
          </mat-form-field> -->
          <mat-form-field class="basis-full">
            <mat-label>On hire time</mat-label>
            <input matInput name="on_hire_time" formControlName="on_hire_time"
              (blur)="updateTimeEnteredManually('on_hire_time', pickerOn)" placeholder="On hire time" />
            <mat-error *ngIf="form.get('on_hire_time').hasError('invalidTime')">Invalid time value, please enter in the
              format: HH:mm (24
              hour)</mat-error>
            <mat-icon matSuffix (click)="pickerOn.open()">access_time</mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
            (timeSet)="updateTime($event, 'on_hire_time')" #pickerOn></ngx-mat-timepicker>

        </div>
        <div class="flex flex-col justify-start items-stretch sm:flex-row sm:gap-x-2">
          <mat-form-field>
            <mat-label>Off hire date</mat-label>
            <input matInput data-cy="off-hire-date" formControlName="off_hire_date" name="Off hire date"
              autocomplete="off" [min]="
                form.controls['on_hire_date'].value
                  ? form.controls['on_hire_date'].value
                  : minimumDate
              " [matDatepicker]="offHirePicker" placeholder="Off hire date" />
            <mat-datepicker-toggle matSuffix [for]="offHirePicker"></mat-datepicker-toggle>
            <mat-error *ngIf="
                form.controls['off_hire_date'].hasError('matDatepickerMin')
              ">
              Off hire date can not be less than on hire date
            </mat-error>
          </mat-form-field>
          <mat-datepicker #offHirePicker></mat-datepicker>

          <mat-form-field class="basis-full">
            <mat-label>Off hire time</mat-label>
            <input matInput name="off_hire_time" formControlName="off_hire_time"
              (blur)="updateTimeEnteredManually('off_hire_time', pickerOff)" placeholder="Off hire time" />
            <mat-error *ngIf="form.get('off_hire_time').hasError('invalidTime')">Invalid time value, please enter in the
              format: HH:mm (24
              hour)</mat-error>
            <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
            (timeSet)="updateTime($event, 'off_hire_time')" #pickerOff></ngx-mat-timepicker>
        </div>

        <div fxLayout="column" fxLayoutGap="8px">
          <mat-form-field>
            <input matInput name="Purchase order" formControlName="purchase_order" [required]="poRequired$ | async"
              placeholder="Purchase Order" />
            <mat-error *ngIf="form.get('purchase_order').errors?.required">You must provide a Purchase Order for this
              customer.
            </mat-error>
          </mat-form-field>
        </div>

        <p>Booking Status</p>
        <mat-radio-group formControlName="status" fxLayout="row" fxLayoutGap="12px">
          <mat-radio-button [value]="availableStatuses.REQUEST" data-cy="status-quote">Quotation Required
          </mat-radio-button>
          <mat-radio-button [value]="availableStatuses.CUSTOMER_ACCEPTED" data-cy="status-confirmed">Confirmed Booking
          </mat-radio-button>
        </mat-radio-group>
      </form>
    </div>

    <div *ngIf="type === 'hire' || type === 'sale'">
      <form (submit)="create()" [formGroup]="form" fxLayout="column" fxLayoutGap="18px">
        <mat-divider></mat-divider>
        <h4>{{ type | titlecase }} Details</h4>
        <div fxLayout="column" fxLayoutGap="8px">
          @if (multipleCurrencies$ | async) {
          <mat-form-field>
            <mat-label>Currency</mat-label>
            <mat-select formControlName="currency_code" name="Currency" [required]="true">
              <mat-option *ngFor="let currency of currencies$ | async" [value]="currency">
                {{ currency }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('currency_code').errors?.required">You must select a currency for this
              transaction.
            </mat-error>
          </mat-form-field>
          @if (form.get('currency_code').value !== (defaultCurrency$ | async)) {
          <mat-form-field>
            <mat-label>Conversion rate</mat-label>
            <input matInput formControlName="currency_rate" name="Conversion rate" [required]="true" placeholder="Conversion
              rate" />
            <mat-error *ngIf="form.get('currency_rate').errors?.required">You must provide an exchange rate for this
              transaction.
            </mat-error>
          </mat-form-field>
          }
          }
          <mat-form-field>
            <input matInput name="Purchase order" formControlName="purchase_order" [required]="poRequired$ | async"
              placeholder="Purchase Order" />
            <mat-error *ngIf="form.get('purchase_order').errors?.required">You must provide a Purchase Order for this
              customer.
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="dialogRef.close()">
    Cancel
  </button>
  <button [testId]="testIds.SUBMIT" mat-flat-button [disabled]="!form?.valid || !type || loading" type="submit"
    (click)="create()" color="primary">
    Create
    <span *ngIf="type === 'hire'">Hire Contract</span>
    <span *ngIf="type === 'sale'">Sales Invoice</span>
    <span *ngIf="type === 'booking'">Booking</span>
  </button>
</mat-dialog-actions>